var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddEventSolid = function SvgAddEventSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 3a.75.75 0 0 0-1.5 0v1.25H6A2.75 2.75 0 0 0 3.25 7v12A2.75 2.75 0 0 0 6 21.75h12A2.75 2.75 0 0 0 20.75 19V7A2.75 2.75 0 0 0 18 4.25h-1.25V3a.75.75 0 0 0-1.5 0v1.25h-6.5V3Zm-1.5 2.75h1.5V7a.75.75 0 0 1-1.5 0V5.75Zm12 5.25a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1 0-1.5h13a.75.75 0 0 1 .75.75Zm-2.5-5.25h-1.5V7a.75.75 0 0 0 1.5 0V5.75ZM12 13.25a.75.75 0 0 1 .75.75v1.25H14a.75.75 0 0 1 0 1.5h-1.25V18a.75.75 0 0 1-1.5 0v-1.25H10a.75.75 0 0 1 0-1.5h1.25V14a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgAddEventSolid;